import React from 'react';
import PropTypes from 'prop-types';

const Page = ({image, fullScreen, isLCP}) => {
  return (
    <img
      src={image}
      alt="Fotografía de pastelería Annete"
      width={fullScreen ? 1020 : 807}
      height={fullScreen ? 765 : 538}
      // eslint-disable-next-line react/no-unknown-property
      fetchpriority={isLCP ? 'high' : undefined}
      loading={isLCP ? 'eager' : 'lazy'}
      style={fullScreen ? {
        width: '100%',
        height: '100%',
        aspectRatio: '4 / 3',
      } : {
        width: '100%',
        height: '100%',
        aspectRatio: '3 / 2',
      }}
    />
  );
};

Page.propTypes = {
  image: PropTypes.string,
  fullScreen: PropTypes.bool,
  isLCP: PropTypes.bool,
};

export default Page;
